import React from "react";
import Switch from "react-switch";
import PropTypes from 'prop-types';

class Toggle extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    label: PropTypes.string,
    ignoreDisabled: PropTypes.bool,
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    onChange: function () {},
    checked: false,
    label: '',
    ignoreDisabled: false,
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.checked,
      disabled: false,
    };
    this.allowAction = true;
  }

  handleChange = () => {
    let preConditionsMet = true;
    if (this.props.ignoreDisabled) this.setState({ disabled: false });
    if(this.props.preConditions) {
      preConditionsMet = this.props.preConditions();
    }
    if(this.state.disabled === false && preConditionsMet){
      if (!this.allowAction) return;
      this.allowAction = false;
      const promise = new Promise((res) => {
        res(this.props.onChange());
      });
      promise.then(() => {
        this.allowAction = true;
      });
      this.setState({disabled: true});
    }
  };

  componentWillReceiveProps ({ checked }) {
    if (this.state.checked !== checked) {
      this.setState({ checked, disabled: false });
    }
  }

  render() {
    return (
      <label htmlFor="small-switch">
        <span>{this.props.label}</span>
        <Switch
          className={`react-switch ${this.state.checked ? 'on' : 'off'}`}
          onChange={this.handleChange}
          checked={this.state.checked}
          uncheckedIcon={false}
          checkedIcon={false}
          id="small-switch"
          height={22}
          width={40}
          disabled={this.props.disabled}
        />
      </label>
    );
  }
}

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/elements/Switch.js